import React, { useEffect, useState } from "react";
import { Formik, FieldArray, validateYupSchema } from "formik";
import * as Yup from "yup";
import "./dashboard.css";
import * as apicall from "../../components/Apicall";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { FaArrowLeft } from "react-icons/fa";
import Table from "../../constants/Table";
import { Modal } from "react-bootstrap";
import RFQLayout from "./RFQlayout";
import RFQActivityLog from "./RFQActivity";

const RFQForm2 = () => {
  const [vendorList, setVendorList] = useState([]); // full vendor list from API
  const [docDropdownOpen, setDocDropdownOpen] = useState(false);
  const [loading, setLoader] = useState(false);
const [submitType, setSubmitType] = useState("submit"); // submit | draft
  const location = useLocation();
  const initialData = location.state?.formData || null;
  const receivedId = location.state?.id;
const mode = location.state?.mode || "add";
const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");
const rfqStatus = initialData?.RFQ_Data?.[0]?.status;
const isBuyer = userDetails.company_type_id === 1;
const isSupplier = userDetails.company_type_id === 2;
const isDraft = rfqStatus === "0";
const isViewMode = mode === "view";
const isEditMode = mode === "edit";
const [formInitialValues, setFormInitialValues] = useState(null);
const [showActivity, setShowActivity] = useState();
const [activityLog, setActivityLog] = useState();
const today = new Date().toISOString().split("T")[0];
 const navigate = useNavigate();
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.split("T")[0];
};
console.log(mode,"mode")


const getDateOnly = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.substring(0, 10);
};

const getSupplierFullName = (s) =>
  [s.first_name, s.middle_name, s.last_name].filter(Boolean).join(" ");


const validationSchema = Yup.object().shape({
  items2: Yup.array().of(
    Yup.object().shape({
      vendorOptions: Yup.string().required("Please select vendor option"),
      documents: Yup.array().required("Please select Documents"),
      responseDeadline: Yup.string().required("Please Enter Response Deadline"),
      deliveryDate: Yup.string()
        .required("Please Enter Delivery Date")
        .test(
          "delivery-after-response",
          "Delivery date cannot be earlier than response deadline",
          function (value) {
            const { responseDeadline } = this.parent;
            if (!value || !responseDeadline) return true;
            return new Date(value) >= new Date(responseDeadline);
          }
        ),
      deliveryLocation: Yup.string().required("Please select Delivery Location"),
    })
  ),
});


useEffect(() => {
  const init = async () => {
    if (!initialData) return;

    let vendors = [];

    if (
      isEditMode &&
      isDraft &&
      initialData.vendor_option === "Vendor List"
    ) {
      vendors = await fetchVendorsByCategory();
    }

    setFormInitialValues(mapBackendToForm2(initialData));
  };

  init();
}, [initialData, isEditMode, isDraft]);

  const fetchVendorsByCategory = async () => {
    try {
      const category = initialData?.items?.[0]?.category;
      if (!category) return [];
      const res = await apicall.get(`get_vendors?category=${encodeURIComponent(category)}`);
      setVendorList(res?.data || []);
      return res?.data || [];
    } catch {
      setVendorList([]);
      return [];
    }
  };
const fetchActivityLog = async()=>{
   try {
      const category = initialData?.items?.[0]?.category;
      if (!category) return [];
      const res = await apicall.get(`getRFQActivityLog/${initialData?.id}`);
      setActivityLog(res?.data || []);
      return res?.data || [];
    } catch (e) {
          toast.error(e.message.replace("Error:", ""));
    }
}
useEffect(() => {
  if (!initialData) return;

  if (
    isEditMode &&
    isDraft &&
    initialData.vendor_option === "Vendor List"
  ) {
    fetchVendorsByCategory();
  }
}, [isEditMode, isDraft, initialData]);


 const mapBackendToForm2 = (data) => ({
    items2: [
      {
        vendorOptions: data.vendor_option || "",
        selectedVendors: (data.supplier_details || []).map(
        (s) => s.company?.company_id
      ),
        manualVendor: { name: "", email: "", phone: "" },
        instructions: data.instructions || "",
        responseDeadline: formatDate(data.responsible_date),
        deliveryDate: formatDate(data.delivery_date),
        deliveryLocation: data.location || "",
        parameters2:
          data.rfq_required_documents?.[0]?.rfq_param
            ? Object.entries(JSON.parse(data.rfq_required_documents[0].rfq_param)).map(
                ([key, value]) => ({ key, value })
              )
            : [],
        parameters3: data.delivery_params
          ? Object.entries(JSON.parse(data.delivery_params)).map(([key, value]) => ({
              key,
              value,
            }))
          : [],
        documents: data.rfq_required_documents?.map((d) => d.document) || [],
        documentIdsLookup: data.rfq_required_documents?.reduce((acc, d) => {
          acc[d.document] = d.id;
          return acc;
        }, {}),
      },
    ],
  });

const submitRFQ = async (form2Values) => {
  try {
    setLoader(true);

    // Merge Form1 items into payload
    const payload = {
      ...form2Values,            // Form2 values (items2, selectedVendors, delivery, etc)
      items: initialData.items || [], // Form1 items
      id: initialData.id,
      is_draft: false,
      user_id: userDetails.id,
    };

    const res = await apicall.post(payload, "create_rfq");

    if (!res?.success) {
      toast.error("Failed to submit RFQ");
      return;
    }

    toast.success("RFQ submitted successfully");
    navigate("/dashboard");

  } catch (err) {
    toast.error("Failed to submit RFQ");
  } finally {
    setLoader(false);
  }
};



  if (!formInitialValues) {
    return <Loader />;
  }
  return (
          <RFQLayout rfqId={initialData?.id}
        userDetails={userDetails}
        >

  

      <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      enableReinitialize={true}
      onSubmit={async (values) => {
        const firstItem = values.items2[0];

        const rfq_required_documents = firstItem.documents.map((doc) => {
          const paramObj = (firstItem.parameters2 || []).reduce((acc, cur) => {
            if (cur.key) acc[cur.key] = cur.value || "";
            return acc;
          }, {});
          return {
            id: firstItem.documentIdsLookup?.[doc] || null,
            document: doc,
            rfq_param: Object.keys(paramObj).length ? JSON.stringify(paramObj) : null,
          };
        });

        const payload = {
          ...initialData,
          ...values,
          items: initialData.items ?? values.items,
          user_id: userDetails.id,
          is_draft: submitType === "draft",
          items2: [{ ...firstItem, rfq_required_documents }],
        };

       try {
  setLoader(true);

  const res = await apicall.post(payload, "create_rfq");

  const isUpdated = res?.data?.updated === true;

  if (isUpdated) {
    toast.success("RFQ Updated Successfully");
  } else {
    toast.success(
      submitType === "draft"
        ? "RFQ saved as draft"
        : "RFQ Created Successfully"
    );
  }

  navigate("/dashboard");

} catch (err) {
  console.error("RFQ submit error:", err);
  toast.error("Failed to submit RFQ");
} finally {
  setLoader(false);
}

      }}
    >
      {(formik) => {
        // helper to toggle vendor selection
        const toggleVendor = (vendorId) => {
          const selected = formik.values.items2[0].selectedVendors || [];
          const updated = selected.includes(vendorId)
            ? selected.filter((v) => v !== vendorId)
            : [...selected, vendorId];
          formik.setFieldValue("items2[0].selectedVendors", updated);
        };

        const selectAllVendors = () => {
formik.setFieldValue(
  "items2[0].selectedVendors",
  vendorList.map(c => c.company_id)
);

};

        const clearAllVendors = () => {
          formik.setFieldValue("items2[0].selectedVendors", []);
        };

const handleVendorOptionChange = async (value) => {
          formik.setFieldValue("items2[0].vendorOptions", value);

          if (value === "Vendor List") {
            await fetchVendorsByCategory();
            return;
          }

          if (value === "All") {
            const data = await fetchVendorsByCategory();
            formik.setFieldValue(
              "items2[0].selectedVendors",
              data.map((c) => c.company_id)
            );
            return;
          }

          formik.setFieldValue("items2[0].selectedVendors", []);
        };

const supplierHeaders = ["Company", "Company Address", "Country"];
const uniqueSuppliers = Object.values(
  (initialData?.supplier_details || []).reduce((acc, item) => {
    const key = item.company_profile_id || item.company_name;

    if (!acc[key]) {
      acc[key] = item;
    }

    return acc;
  }, {})
);

const supplier_Data = uniqueSuppliers.map(item => [
  item.company_name,
  item.company_address,
  item.country,
])



        return (
  <form onSubmit={formik.handleSubmit} className="rfq-container">
                        <div className="rfq-card">

            {/* <div className="rfq-scroll"> */}
           {/* <h3>
             <FaArrowLeft
               className="me-2 cursor-pointer"
               size={20}
               onClick={() => navigate(-1)}
             />
             {mode === "edit" ? "Edit RFQ" : mode === "view" ? "View Details" : "Create RFQ"}
           </h3>
                     <h6 style={{marginLeft:"30px"}}>
             {(mode === "edit" || mode === "view") && initialData?.display_id}
           </h6> */}


{isBuyer && (mode === "add" || isDraft) && (
   <div className="card">
                <h2 className="section-title">Select Vendors</h2>
                <p className="section-subtitle">Choose which vendors to send this RFQ to</p>

                {/* Radio options */}
                {[
                  {
                    value: "All",
                    title: "Send to all Vendors",
                    desc: "Automatically sends RFQ to all vendors",
                  },
                  {
                    value: "Favorite",
                    title: "Select from Favorite Vendors",
                    desc: "Choose vendors from your favorite list",
                  },
                  {
                    value: "Vendor List",
                    title: "Select from Vendor List",
                    desc: "Choose vendors from the complete list",
                  },
                  {
                    value: "Manual",
                    title: "Add manual vendor",
                    desc: "Send RFQ directly to vendor",
                  },
                ].map((opt) => (
                  <div key={opt.value} style={{ marginBottom: 8 }}>
                    <label className="radio-option flex items-start gap-2 mb-1" style={{ display: "flex", alignItems: "flex-start" }}>
                      <input
                        type="radio"
                        name="items2[0].vendorOptions"
                        value={opt.value}
                        checked={formik.values.items2[0].vendorOptions === opt.value}
                        onChange={() => handleVendorOptionChange(opt.value)}
                        style={{ marginTop: 4 }}
                      />
                      <div>
                        <strong>{opt.title}</strong>
                        <p className="desc text-sm text-gray-500" style={{ margin: 0 }}>{opt.desc}</p>
                      </div>
                    </label>

                    {/* If this is Vendor List option, show compact vendor box beneath this radio */}
                    {opt.value === "Vendor List" && formik.values.items2[0].vendorOptions === "Vendor List" && (
                      <div
                        className="vendor-box"
                        style={{
                          marginLeft: 28,
                          marginTop: 6,
                          border: "1px solid #e6e6e6",
                          borderRadius: 8,
                          width: 320,
                          maxHeight: 200,
                          overflowY: "auto",
                          background: "#fff",
                          padding: 8,
                        }}

                      >
                        {/* Select All / Clear */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                          <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
  type="checkbox"
  checked={
    vendorList.length > 0 &&
    formik.values.items2[0].selectedVendors.length === vendorList.length
  }
  onChange={(e) => {
    if (e.target.checked) {
      formik.setFieldValue(
        "items2[0].selectedVendors",
        vendorList.map(c => c.company_id)
      );
    } else {
      formik.setFieldValue("items2[0].selectedVendors", []);
    }
  }}
/>

                            <span style={{ fontSize: 14 }}>Select All</span>
                          </label>
                        
                        </div>

                       {vendorList.length === 0 ? (
  <div style={{ padding: 10, color: "#666" }}>No vendors available for selected category.</div>
) : (
  vendorList.map((company) => (
    <label
      key={company.company_id}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 6px",
        borderTop: "1px solid #f1f1f1",
        cursor: "pointer",
      }}
    >
      <input
  type="checkbox"
  checked={(formik.values.items2[0].selectedVendors || []).includes(
    company.company_id
  )}
  onChange={() => {
    const selected = formik.values.items2[0].selectedVendors || [];
    const updated = selected.includes(company.company_id)
      ? selected.filter(id => id !== company.company_id)
      : [...selected, company.company_id];

    formik.setFieldValue("items2[0].selectedVendors", updated);
  }}
/>

      <span style={{ fontSize: 14 }}>{company.company_name}</span>
    </label>
  ))
)}

                      </div>
                    )}
                  </div>
                ))}

                {/* Display validation for vendorOptions */}
                {formik.touched.items2?.[0]?.vendorOptions && formik.errors.items2?.[0]?.vendorOptions && (
                  <div className="invalid-feedback d-block mx-2 mt-2">{formik.errors.items2[0].vendorOptions}</div>
                )}

                {/* Manual vendor fields */}
                {formik.values.items2[0].vendorOptions === "Manual" && (
                  <div className="form-row grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                    <div>
                      <label className="label mb-1">Vendor Name</label>
                      <input
                        type="text"
                        name="items2[0].manualVendor.name"
                        value={formik.values.items2[0].manualVendor.name}
                        onChange={formik.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div>
                      <label className="label mb-1">Email Address</label>
                      <input
                        type="email"
                        name="items2[0].manualVendor.email"
                        value={formik.values.items2[0].manualVendor.email}
                        onChange={formik.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div>
                      <label className="label mb-1">Phone</label>
                      <input
                        type="text"
                        name="items2[0].manualVendor.phone"
                        value={formik.values.items2[0].manualVendor.phone}
                        onChange={formik.handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                )}

                {/* Additional Instructions */}
                <div className="mt-3">
                  <label className="label">Additional Instructions</label>
                  <textarea
                    name="items2[0].instructions"
                    placeholder="Enter message here..."
                    value={formik.values.items2[0].instructions}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              )}
{isBuyer &&
  (mode === "edit" || mode === "view") &&
  supplier_Data?.length > 0 && (
    <div className="card mt-4">
      <h2 className="section-title">Supplier Details</h2>
      <p className="section-subtitle">Suppliers this RFQ is sent to</p>

      <Table
        headers={supplierHeaders}
        data={supplier_Data}
        pagination={false}
        recordsCount={supplier_Data.length}
        Action={null}
        actionType={null}
      />
    </div>
  )}

             

           {/* Documents Required */}
<div
  className={`card shadow-sm border rounded-lg p-4 bg-white mt-4 ${
    mode === "view" ? "opacity-60 pointer-events-none" : ""
  }`}
>  <h2 className="section-title">Documents Required</h2>
  <p className="text-sm text-gray-500 mb-3">Select all documents required for this RFQ</p>
  <div className="relative w-full">
    <div
  className={`flex justify-between items-center border border-gray-300 rounded-lg px-3 py-2 bg-white ${
    mode === "view" ? "cursor-not-allowed" : "cursor-pointer"
  }`}
  onClick={() => {
    if (mode === "view") return;
    setDocDropdownOpen(!docDropdownOpen);
  }}
>

      <span className="text-gray-700 text-sm truncate">
        {formik.values.items2[0].documents.length > 0
          ? formik.values.items2[0].documents.join(", ")
          : "Select documents"}
      </span>
      <span className="ml-2 text-gray-500">&#9662;</span>
    </div>

    {docDropdownOpen && (
      <div className="absolute w-full z-10 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto flex flex-col space-y-1">
        {["AADHAR", "PAN", "Bank Account", "Address Proof"].map((doc) => {
          const currentDocs = formik.values.items2[0].documents || [];
          const isChecked = currentDocs.includes(doc);

          const handleChange = () => {
            if (isChecked) {
              formik.setFieldValue(
                "items2[0].documents",
                currentDocs.filter((d) => d !== doc)
              );
            } else {
              formik.setFieldValue("items2[0].documents", [...currentDocs, doc]);
            }
          };

          return (
            <label
              key={doc}
              className="flex items-center gap-2 px-3 py-2 cursor-pointer transition-all duration-150 hover:bg-gray-100 border-b last:border-b-0"
            >
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleChange}
                className="accent-blue-600 cursor-pointer"
              />
              <span className="text-gray-800 text-sm">{doc}</span>
            </label>
          );
        })}

        {/* "Select All" option */}
        <label className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100">
          <input
          
            type="checkbox"
            checked={
              ["AADHAR", "PAN", "Bank Account", "Address Proof"].every((d) =>
                formik.values.items2[0].documents.includes(d)
              )
            }
            onChange={() => {
              const allDocs = ["AADHAR", "PAN", "Bank Account", "Address Proof"];
              const isAllSelected = allDocs.every((d) =>
                formik.values.items2[0].documents.includes(d)
              );
              formik.setFieldValue(
                "items2[0].documents",
                isAllSelected ? [] : allDocs
              );
            }}
          />
          <span className="text-gray-800 text-sm">Select All</span>
        </label>
      </div>
    )}
  </div>

  {/* Parameters for each document */}
  <FieldArray name="items2[0].parameters2">
    {({ push, remove }) => (
      <div className="mt-3">
        <button type="button" disabled={mode==="view"} className="add-param mt-2" onClick={() => push({ key: "", value: "" })}>
          List additional documents
        </button>

        {formik.values.items2[0].parameters2?.map((param, index) => (
          <div key={index} className="row align-items-center mt-2">
            <div className="col-3">
              <input
                type="text"
                disabled={mode==="view"} 
                name={`items2[0].parameters2.${index}.key`}
                className="form-control"
                placeholder="Parameter Name"
                value={param.key}
                onChange={formik.handleChange}
              />
            </div>

            <div className="col-3">
              <input
                type="text"
                disabled={mode==="view"} 
                name={`items2[0].parameters2.${index}.value`}
                className="form-control"
                placeholder="Parameter Value"
                value={param.value}
                onChange={formik.handleChange}
              />
            </div>

            <div className="col-1 text-center">
              <button
                disabled={mode==="view"} 
                type="button"
                onClick={() => remove(index)}
                className="btn"
                style={{ border: "1px solid black" }}
              >
                ❌
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </FieldArray>
</div>


              {/* Delivery Details */}
              <div className="card mt-4">
                <h2 className="section-title">Delivery Details</h2>
                <div className="form-row grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="label">Response Deadline</label>
                    <input 
                    disabled={mode==="view"} 
                    type="date" name="items2[0].responseDeadline"
                    value={formik.values.items2[0].responseDeadline}
                    onChange={formik.handleChange} 
                    className="form-control" 
                    min={today}
                    
                    />
                     {formik.touched.items2?.[0]?.responseDeadline && formik.errors.items2?.[0]?.responseDeadline && (
                  <div className="invalid-feedback d-block mx-2 mt-2">{formik.errors.items2[0].responseDeadline}</div>
                )}
                  </div>
                  <div>
                    <label className="label">Expected Delivery Date</label>
                    <input
                    disabled={mode==="view"} 
  type="date"
  name="items2[0].deliveryDate"
  value={formik.values.items2[0].deliveryDate || ""}
  onChange={formik.handleChange}
  className={`form-control ${
    formik.touched.items2?.[0]?.deliveryDate && formik.errors.items2?.[0]?.deliveryDate ? "is-invalid" : ""
  }`}
  min={today}
/>
{formik.touched.items2?.[0]?.deliveryDate && formik.errors.items2?.[0]?.deliveryDate && (
  <div className="invalid-feedback">{formik.errors.items2[0].deliveryDate}</div>
)}

                  </div>
                  <div>
                    <label className="label">Delivery Location</label>
                    <input
                     disabled={mode==="view"} 
                    type="text" name="items2[0].deliveryLocation" value={formik.values.items2[0].deliveryLocation} onChange={formik.handleChange} className="form-control" />
                   {formik.touched.items2?.[0]?.deliveryLocation && formik.errors.items2?.[0]?.deliveryLocation && (
                  <div className="invalid-feedback d-block mx-2 mt-2">{formik.errors.items2[0].deliveryLocation}</div>
                )}
                  </div>
                </div>

                <FieldArray name="items2[0].parameters3">
  {({ push, remove }) => (
    <div className="mt-3">

      <button
      disabled={mode==="view"} 
        type="button"
        className="add-param mt-2"
        onClick={() => push({ key: "", value: "" })} // push key-value object
      >
        + Add Parameter
      </button>

      {formik.values.items2[0].parameters3?.map((param, index) => (
        <div key={index} className="row align-items-center mt-2">

          <div className="col-3">
            <input
              type="text"
                    disabled={mode==="view"} 
              name={`items2[0].parameters3.${index}.key`}
              className="form-control"
              placeholder="Parameter Name"
              value={param.key}
              onChange={formik.handleChange}
            />
          </div>

          <div className="col-3">
            <input
              type="text"
                    disabled={mode==="view"} 

              name={`items2[0].parameters3.${index}.value`}
              className="form-control"
              placeholder="Parameter Value"
              value={param.value}
              onChange={formik.handleChange}
            />
          </div>

          <div className="col-1 text-center">
            <button
                  disabled={mode==="view"} 

              type="button"
              onClick={() => remove(index)}
              className="btn btn"
                            style={{ border: "1px solid black" }}

            >
              ❌
            </button>
          </div>

        </div>
      ))}

    </div>
  )}
</FieldArray>


              </div>
            {/* </div> */}
{isBuyer && isEditMode && isDraft && (
  <div className="rfq-actions mt-4">
    <button className="back-btn" onClick={() => navigate(-1)}>
      Back
    </button>

    <button
      type="button"
      className="submit-btn"
      disabled={loading}
      onClick={() => submitRFQ(formik.values)} // send to suppliers
    >
      {loading ? <Loader /> : "Submit RFQ"}
    </button>
  </div>
)}
{isBuyer && isEditMode && !isDraft && (
  <div className="rfq-actions mt-4">
    <button className="back-btn" onClick={() => navigate(-1)}>
      Back
    </button>

    <button
      type="submit"
      className="submit-btn"
      disabled={loading && submitType === "submit"}
      onClick={() => setSubmitType("submit")}
    >
      {loading && submitType === "submit" ? <Loader /> : "Update RFQ"}
    </button>
  </div>
)}

{isBuyer && !isEditMode && !isViewMode && (
  <div className="rfq-actions flex justify-between mt-4">
<button
  type="button"
  className="back-btn"
  onClick={() =>
    navigate("/rfq", {
      state: {
        mode,
        formData: {
          ...initialData,        // backend + previous data
          items: initialData.items, // 🔥 Form1 data
          items2: formik.values.items2, // 🔥 Form2 current data
        },
      },
    })
  }
>
  Back
</button>


    <div className="flex gap-2">
      <button
        type="button"
        className="draft-btn"
        disabled={loading && submitType === "draft"}
        onClick={() => {
          setSubmitType("draft");
          formik.submitForm();
        }}
      >
        {loading && submitType === "draft" ? <Loader /> : "Save as Draft"}
      </button>

      <button
        type="button"
        className="submit-btn"
        disabled={loading && submitType === "submit"}
        onClick={() => {
          setSubmitType("submit");
          formik.submitForm();
        }}
      >
        {loading && submitType === "submit" ? <Loader /> : "Submit RFQ"}
      </button>
    </div>
  </div>
)}



</div>
          </form>
        
        );
      }}
    </Formik>
    
  
</RFQLayout>


  );
};

export default RFQForm2;
